import React, { ReactElement } from "react";
import Tooltip from "@mui/material/Tooltip";
import { useTranslation } from "react-i18next";
import { BaseLogo } from "../../../core/models/entities/BaseLogo";
import { isLogoNavWriteBackPending } from "../../../utils/functions/logoRejectAndEdit";

// "Sending to supplier" (flag REACT_APP_LOGO_REJECT_AND_EDIT_NAV_ENABLED, API
// flag LogoNavWriteBackMode): the dealer fixed a logo that was already
// committed to the supplier and approved it again - KitMaker keeps the SAME
// item number and the API's worker is writing the method / size / colours to
// the supplier system (NAV) and re-importing the item. The API says so with
// navWriteBackPending=true on the logo; the field is absent on every other
// logo and while the API flag is off. Renders NOTHING unless the FE flag is
// on AND the field is exactly true - the flag-off DOM is byte-identical to
// today. Same look as the design's NavPendingBadge / ProductPendingBadge
// (10 px status line in the pending tone with a pulsing dot), so the status
// column reads as one family. No timer, no extra request: the badge leaves
// with the next read of the logo.
export function NavWriteBackPendingBadge({
  logo,
  className,
}: {
  logo: BaseLogo | null | undefined;
  className?: string;
}): ReactElement | null {
  const { t } = useTranslation();
  if (!isLogoNavWriteBackPending(logo)) return null;
  return (
    <Tooltip title={t("logoList.navWriteBackPendingTooltip")} placement="top">
      <span
        data-testid="logo-nav-writeback-pending-badge"
        className={`inline-flex items-center gap-2 whitespace-nowrap text-xs font-semibold text-status-pending-1 ${
          className ?? ""
        }`}
      >
        <span
          aria-hidden="true"
          className="h-[0.25rem] w-[0.25rem] shrink-0 rounded-full bg-status-pending-1 motion-safe:animate-pulse"
        />
        {t("logoList.navWriteBackPending")}
      </span>
    </Tooltip>
  );
}
